export default "__VITE_ASSET__85652198__"